import React from 'react';
import { useSelector } from 'react-redux';
import { colors } from '../../../theme/style';

export default function DiagnosticSelector({ index, updateDiagnosInd }) {
  const { patient } = useSelector((state) => state.user);
  const diagnosis = patient?.diagnosis || [];
  const onDiagnoseIncreaseChange = () => {
    if (index < Object.keys(diagnosis).length - 1) {
      updateDiagnosInd(index + 1);
    }
  };

  const onDiagnoseDecreaseChange = () => {
    if (index != 0) {
      updateDiagnosInd(index - 1);
    }
  };
  return (
    <div className="row" style={{ alignItems: 'center' }}>
      <div onClick={onDiagnoseDecreaseChange} style={index != 0 ? styles.buttonScroll : styles.buttonScrollNoMore}>
        {'<'}
      </div>
      <div>Diagnosis</div>
      <div onClick={onDiagnoseIncreaseChange} style={index < Object.keys(diagnosis).length - 1 ? styles.buttonScroll : styles.buttonScrollNoMore}>
        {'>'}
      </div>
    </div>
  );
}

const styles = {
  buttonScroll: {
    cursor: 'pointer',
    border: 'none',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonScrollNoMore: {
    cursor: 'pointer',
    border: 'none',
    color: colors.purpleGrey,
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
};
